<template>
  <div
    id="system-settings"
    class="page page-data-management"
  >
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <h4 class="m-0">
        System Settings
      </h4>
    </div>
    <div
      id="pageContent"
      class="page-content d-flex flex-column p-3"
    >
      <content-spinner :show="isSpinnerNecessary" />
      <template v-if="isDataExist">
        <tabs-component
          :tabs-data="tabsData"
          @get-selected-tab="getSelectedTab"
        />
        <system-settings-card
          v-for="item of data"
          v-if="selectedTab === item.cardId"
          :key="item.id"
          :item="item"
        />
        <feature-flags-card 
          v-if="selectedTab === 'featureFlags'"
        />
      </template>
    </div>
    <test-email-modal />
  </div>
</template>

<script>
import ContentSpinner from '@/core/components/ContentSpinner.vue';
import {createNamespacedHelpers} from 'vuex';
import SystemSettingsCard from '@/modules/Security/components/SystemSettingsCard.vue';
import TestEmailModal from '@/modules/Security/components/TestEmailModal.vue';
import FeatureFlagsCard from '@/modules/Security/components/FeatureFlagsCard.vue';
import TabsComponent from '@/modules/Security/components/TabsComponent.vue';

const {mapState, mapActions} = createNamespacedHelpers('systemInfo');

export default {
  name: 'SystemSettingsView',
  components: {
    TestEmailModal,
    SystemSettingsCard,
    FeatureFlagsCard,
    ContentSpinner,
    TabsComponent,
  },
  data() {
    return {
      selectedTab: 'adpConfig',
    };
  },
  computed: {
    ...mapState({
      isLoading: state => state.systemSettings.loading,
      isModalOpened: state => state.systemSettings.testEmailModal.isOpen,
      data: state => state.systemSettings.data,
    }),
    isSpinnerNecessary() {
      return this.isLoading && !this.data.length;
    },
    isDataExist() {
      return !!this.data.length;
    },
    // Create the tabs from the systemSettings data plus hardcode feature flags (as not in systemSettings data)
    tabsData() {
      const tabs = this.data.map((item, index) => ({
        id: index + 1,
        label: item.title,
        value: item.cardId,
        icon: item.cardId === 'defaultLogLevel' ? 'file-alt' : 'gear',
      }));
      tabs.push({ id: tabs.length + 1, label: 'Feature Flags', value: 'featureFlags', icon: 'flag' });
      return tabs;
    },
  },
  methods: {
    ...mapActions(['getSystemSettingsData']),
    getSelectedTab(tab) {
      this.selectedTab = tab;
    },
  },
  async mounted() {
    await this.getSystemSettingsData();
  },
};
</script>